import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserprofile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7 8C9.1875 8 11 6.21875 11 4C11 1.8125 9.1875 0 7 0C4.78125 0 3 1.8125 3 4C3 6.21875 4.78125 8 7 8ZM7 1C8.625 1 10 2.375 10 4C10 5.65625 8.625 7 7 7C5.34375 7 4 5.65625 4 4C4 2.375 5.34375 1 7 1ZM8.5625 9.5H5.40625C2.40625 9.5 0 11.9375 0 14.9375C0 15.5312 0.46875 16 1.0625 16H12.9062C13.5 16 14 15.5312 14 14.9375C14 11.9375 11.5625 9.5 8.5625 9.5ZM12.9062 15H1.0625C1.03125 15 1 14.9688 1 14.9375C1 12.5 2.96875 10.5 5.40625 10.5H8.5625C11 10.5 13 12.5 13 14.9375C13 14.9688 12.9375 15 12.9062 15Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgUserprofile);
export { ForwardRef as ReactComponent };
